import { TabIdList, TabColorList } from './tab-list.enums';

export const mapColorToTabIdList: { [key in TabIdList]: TabColorList } = {
  [TabIdList.DataCollection]: TabColorList.DataCollection,
  [TabIdList.InformationUsage]: TabColorList.InformationUsage,
  [TabIdList.InformationDisclosure]: TabColorList.InformationDisclosure,
  [TabIdList.InformationSharing]: TabColorList.InformationSharing,
  [TabIdList.Rights]: TabColorList.Rights,
  [TabIdList.InformationStoring]: TabColorList.InformationStoring,
  [TabIdList.SecurityAndAge]: TabColorList.SecurityAndAge,
  [TabIdList.ContactUs]: TabColorList.ContactUs,
  [TabIdList.UsResidents]: TabColorList.UsResidents,
};
